import React from 'react';
import { Form } from 'react-bootstrap';
import type { CabConclusaoLayout } from '../cabPresentationTemplates';

type Props = {
  layout: CabConclusaoLayout;
  canManage: boolean;
  onChange: (next: CabConclusaoLayout) => void;
};

const CabDeckConclusaoEditor: React.FC<Props> = ({ layout, canManage, onChange }) => {
  return (
    <div className="mb-3">
      <h3 className="h6">Datas do cronograma</h3>
      <p className="small text-muted">
        Formato sugerido dd/mm/yyyy. Clique em qualquer célula da matriz para posicionar a estrela.
        Não há vínculo automático com go-live.
      </p>
      {layout.dates.map((date, dateIndex) => (
        <Form.Group key={`date-edit-${dateIndex}`} className="mb-2">
          <Form.Label className="small mb-0">
            Coluna {dateIndex + 1}
            {layout.phases[dateIndex] ? ` (${layout.phases[dateIndex]})` : ''}
          </Form.Label>
          <Form.Control
            size="sm"
            disabled={!canManage}
            value={date}
            onChange={(e) => {
              const dates = layout.dates.map((d, i) => (i === dateIndex ? e.target.value : d));
              onChange({ ...layout, dates });
            }}
          />
        </Form.Group>
      ))}
      <Form.Text className="d-block">
        Estrela atual: {layout.phases[layout.star_phase_index ?? -1] || '—'} ×{' '}
        {layout.dates[layout.star_date_index ?? -1] || '—'}
      </Form.Text>
    </div>
  );
};

export default CabDeckConclusaoEditor;
